// import React, { useState } from "react";
// import { FaStar, FaRegStar } from "react-icons/fa";
// import Rating from "react-rating";
// import { Button, Input } from "reactstrap";
// import { PRIMARY_TEXT_COLOR } from "../color";

// const RatingSummary = ({
//   heading,
//   id,
//   name,
//   ratingsState,
//   setRatingsState,
//   size = 20,
//   fractions = 2,
// }) => {
  
//   const handleRatingChange = (value) => {
//     setRatingsState({
//       ...ratingsState,
//       [id]: ratingsState[id] === value ? 0 : value,
//     });
//   };

//   const handleInputChange = (e) => {
//     setRatingsState({
//       ...ratingsState,
//       [name]: e.target.value,
//     });
//   };

//   const handleReset = () => {
//     setRatingsState({
//       ...ratingsState,
//       [id]: 0
//     });
//   };


//   return (
//     <div className="star-rating-container mb-3 p-3 border rounded-lg shadow-sm bg-white">
//       <div className="d-flex justify-content-between align-items-center">
//         <p className="text-muted" style={{ fontSize: "12px" }}>{heading}</p>
//         <button
//           className="cancelBtn py-0 px-2 text-sm font-semibold text-primary hover:bg-gray-100 rounded-md transition duration-300"
//           onClick={() => handleReset(0)} // Explicitly reset the rating to 0
//         >
//           Reset
//         </button>
//       </div>

//       <div className="d-flex align-items-center">
//         <Rating
//           emptySymbol={<FaRegStar size={size} color="#ffe234" />}
//           fullSymbol={<FaStar size={size} color="#ffe234" />}
//           fractions={fractions}
//           initialRating={ratingsState[id] || 0} // Get the rating for the specific id, default to 0
//           onChange={handleRatingChange}
//         />
//         <span className="ml-2 text-green-600" style={{ fontSize: "14px" }}>
//           {ratingsState[id] || 0}/5
//         </span>
//       </div>
//       <span className="text-green-600" style={{ fontSize: "14px" }}>Remark</span>
//       <Input
//         type="textarea"
//         name={name}
//         style={{
//           padding:"5px 10px"
//         }}
//         placeholder="Write your remark..."
//         value={ratingsState[name] || ""}
//         onChange={handleInputChange}
//       />

//     </div>
//   );
// };

// export default RatingSummary;



import React from "react";
import { FaStar, FaRegStar } from "react-icons/fa";
import Rating from "react-rating";
import { Input, Label } from "reactstrap";

const weekDays = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const RatingSummary = ({
  heading,
  id,
  name,
  ratingsState,
  setRatingsState,
  size = 20,
  fractions = 2,
}) => {

  // Rating Change
  const handleRatingChange = (value) => {
    setRatingsState({
      ...ratingsState,
      [id]: ratingsState[id] === value ? 0 : value,
    });
  };

  // Normal Remark Change
  const handleInputChange = (e) => {
    setRatingsState({
      ...ratingsState,
      [name]: e.target.value,
    });
  };

  /**
   * SAFELY HANDLE OLD STRING DATA
   *
   * Old Data:
   * "Good candidate"
   *
   * New Data:
   * '[{"day":"Monday","dayShift":true}]'
   */

  let parsedAvailability = [];
  
  if (heading === "Availability" && ratingsState[name]) {
   console.log("Parsing availability for:", ratingsState);
    try {
      const parsed = JSON.parse(ratingsState.availabilityRemark);
      console.log("Parsed availability:", parsed);
      if (Array.isArray(parsed)) {
        parsedAvailability = parsed;
      }
    } catch (error) {
     
      // Old string remark → ignore
      parsedAvailability = [];
    }
  }

  // Get Checkbox Value
  const getAvailability = (day, shift) => {
    const found = parsedAvailability.find(
      (item) => item.day === day
    );

    if (!found) return false;

    return found[shift] || false;
  };

  // Handle Availability Change
  const handleAvailabilityChange = (
    day,
    shiftType,
    checked
  ) => {

    let updatedAvailability = [...parsedAvailability];

    const existingDayIndex = updatedAvailability.findIndex(
      (item) => item.day === day
    );

    if (existingDayIndex !== -1) {
      updatedAvailability[existingDayIndex][shiftType] =
        checked;
    } else {
      updatedAvailability.push({
        day,
        dayShift:
          shiftType === "dayShift" ? checked : false,
        nightShift:
          shiftType === "nightShift" ? checked : false,
      });
    }

    setRatingsState({
      ...ratingsState,
      [name]: JSON.stringify(updatedAvailability),
    });
  };

  // Reset
  const handleReset = () => {
    setRatingsState({
      ...ratingsState,
      [id]: 0,
      [name]:
        heading === "Availability"
          ? JSON.stringify([])
          : "",
    });
  };

  return (
    <div className="star-rating-container mb-3 p-3 border rounded shadow-sm bg-white">

      {/* Header */}
      <div className="d-flex justify-content-between align-items-center">
        <p
          className="text-muted mb-1"
          style={{ fontSize: "12px" }}
        >
          {heading}
        </p>

        <button
          className="cancelBtn py-0 px-2"
          onClick={handleReset}
        >
          Reset
        </button>
      </div>

      {/* Rating */}
      <div className="d-flex align-items-center mb-3">
        <Rating
          emptySymbol={
            <FaRegStar size={size} color="#ffe234" />
          }
          fullSymbol={
            <FaStar size={size} color="#ffe234" />
          }
          fractions={fractions}
          initialRating={ratingsState[id] || 0}
          onChange={handleRatingChange}
        />

        <span
          className="ml-2 text-green-600"
          style={{ fontSize: "14px" }}
        >
          {ratingsState[id] || 0}/5
        </span>
      </div>

      {/* Availability Section */}
      {heading === "Availability" ? (
        <div className="mt-3">

          <Label className="fw-bold mb-2">
            Availability
          </Label>

          {weekDays.map((day) => (
            <div
              key={day}
              className="d-flex justify-content-between align-items-center border rounded p-2 mb-2"
            >
              <div style={{ width: "120px" }}>
                <strong>{day}</strong>
              </div>

              <div className="d-flex gap-4">

                {/* Day Shift */}
                <div className="d-flex align-items-center">
                  <Input
                    type="checkbox"
                    checked={getAvailability(
                      day,
                      "dayShift"
                    )}
                    onChange={(e) =>
                      handleAvailabilityChange(
                        day,
                        "dayShift",
                        e.target.checked
                      )
                    }
                  />

                  <Label className="ms-2 mb-0">
                    Day Shift
                  </Label>
                </div>

                {/* Night Shift */}
                <div className="d-flex align-items-center">
                  <Input
                    type="checkbox"
                    checked={getAvailability(
                      day,
                      "nightShift"
                    )}
                    onChange={(e) =>
                      handleAvailabilityChange(
                        day,
                        "nightShift",
                        e.target.checked
                      )
                    }
                  />

                  <Label className="ms-2 mb-0">
                    Night Shift
                  </Label>
                </div>

              </div>
            </div>
          ))}
        </div>
      ) : (
        // Normal Remark Section
        <div>
          <span
            className="text-green-600"
            style={{ fontSize: "14px" }}
          >
            Remark
          </span>

          <Input
            type="textarea"
            style={{
              padding: "5px 10px",
            }}
            placeholder="Write your remark..."
            value={ratingsState[name] || ""}
            onChange={handleInputChange}
          />
        </div>
      )}
    </div>
  );
};

export default RatingSummary;